export const statusColors: any = {
  '03': { backgroundColor: '#ef4444', color: '#ffffff' },
  '10': { backgroundColor: '#6b7280', color: '#ffffff' },
  '11': { backgroundColor: '#6e1eafff', color: '#ffffff' },
  '12': { backgroundColor: '#fb7185', color: '#ffffff' },
  '13': { backgroundColor: '#f97316', color: '#ffffff' },
  '14': { backgroundColor: '#fb7185', color: '#ffffff' },
  '15': { backgroundColor: '#3b82f6', color: '#ffffff' },
  '20': { backgroundColor: '#fb7185', color: '#ffffff' },
  '25': { backgroundColor: '#f97316', color: '#ffffff' },
  '29': { backgroundColor: '#22c55e', color: '#ffffff' },
  '30': { backgroundColor: '#22c55e', color: '#ffffff' },
  '33': { backgroundColor: '#22c55e', color: '#ffffff' },
  '34': { backgroundColor: '#22c55e', color: '#ffffff' },
  '35': { backgroundColor: '#22c55e', color: '#ffffff' },
  '40': { backgroundColor: '#1e40af', color: '#ffffff' },
  '42': { backgroundColor: '#1e40af', color: '#ffffff' },
  '45': { backgroundColor: '#1e40af', color: '#ffffff' },
  '50': { backgroundColor: '#78350f', color: '#ffffff' },
  '89': { backgroundColor: '#ef4444', color: '#ffffff' },
  '90': { backgroundColor: '#ef4444', color: '#ffffff' },
  '95': { backgroundColor: '#ef4444', color: '#ffffff' },

  '06': { backgroundColor: '#f97316', color: '#ffffff' },
  '16': { backgroundColor: '#ef4444', color: '#ffffff' },
  '18': { backgroundColor: '#ffffff', color: '#000000' },
  '23': { backgroundColor: '#fb7185', color: '#ffffff' },
  '32': { backgroundColor: '#22c55e', color: '#ffffff' },
  '37': { backgroundColor: '#f97316', color: '#ffffff' },
  '85': { backgroundColor: '#000000', color: '#ffffff' }
}
